import React, { memo, useEffect, useState } from "react";
import { Modal } from "antd";
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";
import { capitalizeFirst, currencyFormat } from "../../../../utils/common";
import ApproveTask from "../JobBoard/Tasks/ApproveTaskValue/ApproveTask";
import IssuePO from "../JobBoard/Tasks/IssuePO/IssuePO";
import ExtendFrequencyModal from "./ExtendFrequencyModal";
import Task from "../JobBoard/Tasks/Task";

import styles from "../JobStyle.module.css";
import FrequencyShiftsModal from "./FrequencyShiftsModal";
import FrequencyResourcing from "./FrequencyResourcing";


const Frequency = ({ frequency, jobId, selectedTask, selectedJobDetails, refreshHistory, fetchFrequencies, getNextFrequency, setSelectedTask, canManageIssuePO, canManageResourcing, canManageAdjustment }) => {

  const [frequencyState, setFrequencyState] = useState("");
  const [extendFreq, setExtendFreq] = useState(false);
  const [shiftsModal, setShiftsModal] = useState(false);

  useEffect(() => {
    if (frequency && frequency.freq_status) {
      setFrequencyState(frequency.freq_status);
    } else {
      setFrequencyState("Booked");
    }
  }, [frequency])

  const onExtendClose = () => {
    setExtendFreq(false);
  }

  return (
    <div>
      <div className="container-fluid px-0">
        <hr className={`${styles.DetailsDivider} mt-0`}></hr>
      </div>
      <div className="container-fluid px-0">
        <div className="row">
          <div className="col-6">
            <Task canManageAdjustment={canManageAdjustment} isDisabledJob={frequencyState && frequencyState.toString().toLowerCase() === "cancelled"} frequency={frequency} taskDetails={selectedTask} jobId={jobId} fetchFrequencies={fetchFrequencies} />
          </div>
          {canManageAdjustment ? (
            <div className="col-6 d-flex align-items-center justify-content-end" style={{ gap: "10px" }}>
              <ApproveTask
                jobId={jobId}
                task={selectedTask}
                frequency={frequency}
                refreshJobBoard={() => { fetchFrequencies(); refreshHistory(); }} />
            </div>
          ) : null}
        </div>
        {canManageIssuePO || canManageResourcing ? (
          <>
            <hr className={styles.DetailsDivider}></hr>
            <div className="row align-items-center">
              <div className="col-10 px-0">
                {canManageResourcing ? (
                  <FrequencyResourcing
                    refreshJobBoard={() => { fetchFrequencies(); refreshHistory(); }}
                    task={selectedTask}
                    jobId={jobId}
                    frequency={frequency}
                    contractor={frequency.contractor_details && frequency.contractor_details.length ? frequency.contractor_details[0] : null}
                    initialValues={{
                      contractor: frequency.contractor_id && frequency.resource_to ? {
                        label: frequency.resource_to,
                        value: frequency.contractor_id
                      } : null,
                      outsourced_budget: frequency.budget ? currencyFormat(frequency.budget) : "",
                      notes: frequency.notes ? frequency.notes : ""
                    }}
                    form={`frequencyResourcing_${frequency.quote_task_id}`} />
                ) : null}
              </div>
              <div className="col-2 pt-3 d-flex justify-content-end">
                {canManageIssuePO ? (
                  <IssuePO
                    jobId={jobId}
                    frequency={frequency}
                    siteId={selectedTask.site_id}
                    siteName={selectedTask.site_name}
                    task={selectedTask}
                    isDisabled={frequencyState && frequencyState.toString().toLowerCase() === "cancelled"}
                    jobLabel={selectedJobDetails.label}
                    refreshJobBoard={() => { fetchFrequencies(); refreshHistory() }} />
                ) : null}
              </div>
            </div>
          </>
        ) : null}
      </div>
      <Modal
        className="cs-modal-v2"
        centered
        footer={null}
        visible={extendFreq}
        onCancel={() => setExtendFreq(false)}
        afterClose={() => fetchFrequencies()}
        maskClosable={false}
        bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
        destroyOnClose={true}
        width="700px"
        closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
      >
        <ExtendFrequencyModal
          initialValues={{
            start_date: frequency.start_date,
            end_date: moment(frequency.end_date).add(1, "day"),
            freq_type: frequency.freq_type ? frequency.freq_type.toLowerCase() === "none" ? "Does not repeat" : capitalizeFirst(frequency.freq_type, true) : ""
          }}
          form={`extend_frequency_${frequency.quote_task_id}`}
          frequency={frequency}
          task={selectedTask}
          setSelectedTask={setSelectedTask}
          getNextFrequency={getNextFrequency}
          selectedJobDetails={selectedJobDetails}
          onClose={onExtendClose}
        />
      </Modal>
      <Modal
        className="cs-modal-v2"
        centered
        footer={null}
        visible={shiftsModal}
        afterClose={() => fetchFrequencies()}
        onCancel={() => setShiftsModal(false)}
        maskClosable={false}
        bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
        destroyOnClose={true}
        width="60vw"
        style={{ maxWidth: "900px" }}
        closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
      >
        <FrequencyShiftsModal
          frequency={frequency}
          task={selectedTask}
          onClose={() => setShiftsModal(false)}
        />
      </Modal>
    </div>
  )
}

export default memo(Frequency);